<template>
  <portal to="sidebar-menu">
    <div>
      <slot name="before"></slot>
      <nav-list :items="navigationItems"></nav-list>
      <slot name="after"></slot>
    </div>
  </portal>
</template>
<script>

  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'

  export default {
    name: 'contacts-left-menu',
    data () {
      return {
        navigationItems: [
          {
            type: 'group',
            name: this.$t('sidebar.links.clients')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CLIENT),
            hide: !this.$can('admin-clients-all'),
            name: this.$t('sidebar.links.clients')
          },
          {
            routeName: 'clients_check_list',
            hide: !this.$can('admin-clients-all'),
            name: this.$t('sidebar.links.clientsToCheck')
          },
          {
            type: 'group',
            name: this.$t('sidebar.links.users')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.USER),
            hide: !this.$can('admin-users-all'),
            name: this.$t('sidebar.links.users')
          },
        ]
      }
    }
  }
</script>
<style>
</style>
